import { ValidationProperties } from "vue/types/vue";
import { Validation } from "vuelidate";

export const getInvalidLangs = ($vModel: Validation & ValidationProperties<any>) => {
    const invalidLangs: string[] = [];

    for (const key in $vModel) {
        if (Object.prototype.hasOwnProperty.call($vModel, key)) {

            if (key.includes('.') && $vModel[key]?.$error) {

                const skey = key.split('.')[1]

                if (!invalidLangs.includes(skey)) {
                    invalidLangs.push(skey)
                }
            }
        }
    }
    return invalidLangs;
}